export default __webpack_public_path__ + "static/media/kitchen3-after2-480w.2e06dc25.avif";